<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <payroll>
        </payroll> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import payroll from './todo-payslip'
export default {
    components: {
        payroll
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-payroll/base-payslip.vue